import { Skeleton } from '@mui/material';
import { memo } from 'react';

const LOADING_HOURS = [0, 1, 2, 3];

// Segnaposto degli orari, con la misura dei chip, mentre gli altri centri rispondono
export const MultiStoreLoadingHours = memo(
  function MultiStoreLoadingHours(): JSX.Element {
    return (
      <div className="multi-store-hours">
        {LOADING_HOURS.map((index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={60}
            height={30}
            className="multi-store-hour-loading"
          />
        ))}
      </div>
    );
  }
);
